import { render, staticRenderFns } from "./customerInvoice.vue?vue&type=template&id=fc557166&scoped=true&"
import script from "./customerInvoice.vue?vue&type=script&lang=js&"
export * from "./customerInvoice.vue?vue&type=script&lang=js&"
import style0 from "./customerInvoice.vue?vue&type=style&index=0&id=fc557166&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc557166",
  null
  
)

component.options.__file = "customerInvoice.vue"
export default component.exports